import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "timbre-editor" }
const _hoisted_2 = {
  key: 0,
  class: "timbre-editor-box"
}
const _hoisted_3 = { class: "timbre-editor-box-body" }
const _hoisted_4 = { class: "slider-block" }
const _hoisted_5 = { class: "slider-block" }
const _hoisted_6 = { class: "slider-block" }
const _hoisted_7 = { class: "emotion-list-box" }
const _hoisted_8 = { class: "emotion-list-body" }
const _hoisted_9 = ["data-emotion-id", "onClick"]
const _hoisted_10 = ["onClick", "onMouseover", "onMouseleave"]
const _hoisted_11 = { class: "overlay" }
const _hoisted_12 = { class: "emotion-info" }
const _hoisted_13 = { class: "emotion-name" }
const _hoisted_14 = { class: "emotion-desc" }
const _hoisted_15 = { class: "emotion-status" }

import { computed, ref, onMounted, watch, nextTick } from 'vue';
import { getTimbreEmoPage } from '@/request/timbre';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimbreEditor',
  props: {
    selectedVoice: {}
  },
  emits: ['addEmotion', 'audioReady', 'handleEmotionClick', 'refreshEmotionList'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const currentEmotion = ref<any>(null); // 当前选中的情绪
const emotionTimbreList = ref<any[]>([]); // 情绪列表

// 添加情绪
const emit = __emit;

const defaultEmotion = {
  id: '',
  name: '默认',
  status: 2,
};

const loading = ref(false);

// onMounted(() => {
//   fetchEmotionTimbreList();
// });

watch(
  () => props.selectedVoice,
  (newValue) => {
    if (newValue && newValue.id) {
      fetchEmotionTimbreList();
    }
  },
  { immediate: true }
);

async function fetchEmotionTimbreList() {
  // 获取情绪列表
  try {
    loading.value = true;
    const res = await getTimbreEmoPage({
      pageIndex: 1,
      pageSize: 50,
      timbreId: props.selectedVoice.id,
      statusList: [2],
    });
    const { data, code, msg } = res.data;
    if (code === 200 && data.list) {
      // emotionTimbreList.value = [defaultEmotion, ...data.list];
      emotionTimbreList.value = data.list;
      loading.value = false;
      nextTick(() => {
        currentEmotion.value = displayEmotionList.value[0];
        emit('handleEmotionClick', currentEmotion.value);
      });
    }
  } catch (error) {
    console.error(error);
    loading.value = false;
  }
}

const displayEmotionList = computed(() => {
  if (props.selectedVoice.id) {
    return [defaultEmotion, ...emotionTimbreList.value];
  }
  return emotionTimbreList.value;
});

const getStatusType = (status: number) => {
  switch (status) {
    case 0:
      return 'info';
    case 1:
      return 'warning';
    case 2:
      return 'success';
    case -1:
      return 'danger';
    default:
      return 'info';
  }
};

const getStatusText = (status: number) => {
  switch (status) {
    case 0:
      return '未训练';
    case 1:
      return '训练中';
    case 2:
      return '可使用';
    case -1:
      return '不可用';
    default:
      return '不可用';
  }
};

// const currentEmotion = ref<any>(null);
const audio = new Audio();
let currentPlayingItem: any = null;

// 检查是否可以播放音频
function canPlayAudio(item: any) {
  return item.status === 2 && item.refUrl;
}

// 播放音频
function playAudio(item: any) {
  if (currentPlayingItem === item) {
    stopAllAudio();
    return;
  }

  stopAllAudio();
  item.isPlay = true;
  currentPlayingItem = item;
  audio.src = item.refUrl;
  audio.play();

  audio.onended = () => {
    item.isPlay = false;
    currentPlayingItem = null;
  };
}

// 停止所有音频
function stopAllAudio() {
  audio.pause();
  audio.currentTime = 0;
  displayEmotionList.value.forEach((t: any) => (t.isPlay = false));
  currentPlayingItem = null;
}

// 切换播放状态
function togglePlay(item: any) {
  if (!canPlayAudio(item)) return;

  if (item.isPlay) {
    stopAllAudio();
  } else {
    playAudio(item);
  }
}

// 处理情绪点击
function handleEmotionClick(item: any) {
  currentEmotion.value = item;
  emit('handleEmotionClick', item);
}

// 刷新情绪列表
async function refreshEmotionList() {
  await fetchEmotionTimbreList();
}

return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "timbre-editor-header" }, null, -1)),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "timbre-editor-box-header" }, [
            _createElementVNode("span", { class: "title" }, "音调编辑器")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "语速", -1)),
              _createVNode(_component_el_slider, {
                modelValue: _ctx.state.speed,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.speed) = $event)),
                size: "small",
                min: 0.5,
                max: 1.5,
                step: 0.1
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "title" }, "情感", -1)),
              _createVNode(_component_el_slider, {
                modelValue: _ctx.state.emotion,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.emotion) = $event)),
                size: "small",
                min: 50,
                max: 200,
                step: 10
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "title" }, "音量", -1)),
              _createVNode(_component_el_slider, {
                modelValue: _ctx.state.volume,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.volume) = $event)),
                size: "small",
                min: 0,
                max: 10,
                step: 1
              }, null, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
      _createElementVNode("div", { class: "emotion-list-header" }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "title" }, "情绪列表", -1)),
        _createElementVNode("div", {
          class: "refresh-list-btn",
          onClick: refreshEmotionList
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "ri-refresh-line" }, null, -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (displayEmotionList.value.length > 0)
          ? (_openBlock(), _createBlock(_component_el_scrollbar, {
              key: 0,
              class: "emotion-list-scrollbar",
              height: 500
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayEmotionList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    "data-emotion-id": item.id,
                    class: _normalizeClass(["emotion-item", { highlighted: currentEmotion.value?.id === item.id }]),
                    onClick: ($event: any) => (handleEmotionClick(item))
                  }, [
                    _createElementVNode("div", {
                      class: "emotion-avatar",
                      onClick: _withModifiers(($event: any) => (togglePlay(item)), ["stop"]),
                      onMouseover: ($event: any) => (item.isHovering = true),
                      onMouseleave: ($event: any) => (item.isHovering = false)
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["ri-music-2-line play-icon", { rotate: item.isPlay }])
                      }, null, 2),
                      _withDirectives(_createElementVNode("div", _hoisted_11, [
                        _createElementVNode("i", {
                          class: _normalizeClass(item.isPlay ? 'ri-pause-large-line' : 'ri-play-large-line')
                        }, null, 2)
                      ], 512), [
                        [_vShow, (item.isHovering || item.isPlay) && canPlayAudio(item)]
                      ])
                    ], 40, _hoisted_10),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.name || '未命名'), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.refText || '暂无简介'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_tag, {
                        type: getStatusType(item.status)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getStatusText(item.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ])
                  ], 10, _hoisted_9))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              "image-size": 100,
              description: "暂无情绪"
            }))
      ])
    ])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})